<script lang="ts" setup>
const props = defineProps<{
  opened: boolean;
}>();

const { eventGuest } = storeToRefs(useEventGuestStore());
const { supportsRsvp } = usePackageCapabilities();
const musicRef = useTemplateRef("music");

function onToggleMusic() {
  musicRef.value?.onTogglePlay();
}

defineExpose({
  onToggleMusic,
});
</script>

<template>
  <div class="ap-006-floating-actions fixed z-5 flex flex-col gap-4">
    <LazyUiRsvpButton
      v-if="supportsRsvp && eventGuest?.status === 'unconfirmed'"
      :opened="props.opened"
      popover-class="ap-006-rsvp-popover"
      :button-props="{
        size: 'xl',
        variant: 'glass',
        class: 'rounded-full!',
        ui: {
          base: 'size-10 flex items-center justify-center',
          leadingIcon: 'size-6',
          trailingIcon: 'size-6',
        },
      }"
    />
    <LazyPFloatingButtonMusic
      ref="music"
    />
  </div>
</template>

<style scoped>
.ap-006-floating-actions {
  right: calc(1.5rem + env(safe-area-inset-right));
  bottom: calc(2rem + env(safe-area-inset-bottom));
}

@media (min-width: 1280px) {
  .ap-006-floating-actions {
    right: calc(2.5rem + env(safe-area-inset-right));
  }
}
</style>
